import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./UpLoadTimelineModal.module.css";
import {
    Modal,
    TextField,
    // FormControl,
    MenuItem,
    Select,
    Chip,
    ThemeProvider,
    createTheme,
    createStyles,
    makeStyles,
    IconButton,
    // Checkbox,
} from "@material-ui/core";
import { AppState } from "../../../root/RootReducer";
import { GetGroupList, GetUserInfoList } from "../../../user/UserActions";
import SelectTag from "../../../admin/viewer/SelectTag";
import OnLeaveDialog from "../../../common/components/dialog/OnLeaveDialog";
import { countCharLength } from "../../../utils/ValidationUtils";
import { UploadTimeline } from "../../store/actions/TimelineActions";
import { TimelineInfo } from "../../models/Timeline";
import PuiMessage from "../../../components/widgets/PuiMessage";
import UploadDocument from "../../../pages/vod/Common/UploadDocument";
import PuiFloatButton from "../../../components/elements/PuiFloatButton";
import { ResetDuplicateError } from "../../../common/video/VideoActions";
import { Add } from "@material-ui/icons";
import ClearIcon from "@material-ui/icons/Clear";
import { GetTimelineUrlFromId } from "../../../utils/TimelineUtils";

interface UploadTimelineModalProps {
    modalName?: string;
    isOpenLeaveDialogProp: boolean;
    setIsEditUploadTimelineProp: (flag: boolean) => void;
    setIsOpenLeaveDialogProp: (flag: boolean) => void;
    timelineInfo: TimelineInfo;
    closeUploadTimelineModal: (isCloseFromOpenLeaveDialog: boolean) => void;
    ShowUploadTimelineModal: (flag: boolean) => void;
    setIsOpenReuploadModal?: (flag: boolean) => void;
}

const theme = createTheme({
    palette: {
        secondary: {
            main: "#606060",
        },
    },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const useStyles = makeStyles(() =>
    createStyles({
        title: {
            width: "100%",
            background: "#FFFFFF0D",
            borderRadius: "5px",
            fontWeight: "bold",
            "& .MuiInputBase-root": {
                height: "40px",
                "& .MuiInputBase-input": {
                    border: "none",
                    color: "white",
                    opacity: "0.3",
                    fontFamily: "Yu Gothic",
                },
            },
        },
        formSelect: {
            border: "1px solid rgba(255, 255, 255, 0.3)",
            width: "420px",
            height: "40px",
            fontSize: "14px",
            background: "#FFFFFF0D",
            borderRadius: "5px",
            fontFamily: "Yu Gothic",
            "& .MuiSelect-icon": {
                color: "white",
            },
            "& .MuiSelect-selectMenu": {
                color: "white",
            },
        },
        menuItem: {
            backgroundColor: "#323438",
            color: "rgba(255, 255, 255, 0.3)",
            "&:hover": {
                color: "rgba(255, 255, 255, 0.6)",
                backgroundColor: "rgba(1, 1, 1, 0.5)",
            },
            // "& .MuiButtonBase-root": {
            //     color: "rgba(1, 1, 1, 0.5)",
            // },
        },
        textField: {
            width: "100%",
            background: "#FFFFFF0D",
            border: "none",
            borderRadius: "5px",
            "& .MuiInputBase-root": {
                "& .MuiInputBase-input": {
                    height: "189px",
                    color: "white",
                    fontFamily: "Yu Gothic",
                },
            },
        },
    })
);

function UpdateTimelineModal({
    modalName,
    isOpenLeaveDialogProp,
    setIsEditUploadTimelineProp,
    setIsOpenLeaveDialogProp,
    timelineInfo,
    closeUploadTimelineModal,
    setIsOpenReuploadModal,
    ShowUploadTimelineModal,
}: UploadTimelineModalProps) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const inputImageRef = useRef<HTMLInputElement>(null);
    const [isSaved, setIsSaved] = useState(true);
    // ユーザー取得
    const { professionals, groupList } = useSelector((state: AppState) => ({
        professionals: state.user.userInfoList,
        groupList: state.user.groupList,
    }));
    // video本体のdom
    const videoRef = useRef<HTMLVideoElement>(null);
    // ビデオタイトル
    const [inputVideoName, UserInputVideoName] = useState(timelineInfo.title);
    const [isErrorTitleValidation, CheckTitleValidation] = useState(false);

    // サムネイル画像
    const [visiblePreviewImage, ChangevisiblePreviewImage] = useState(false);
    const [inputImageFile, InputImageFile] = useState(null);

    // ビデオ要約
    const [isErrorDescriptionValidation, CheckDescriptionValidation] = useState(false);
    const [inputVideoDetail, InputVideoDetail] = useState("");

    // 資料アップロード
    const [inputDocumentList, ChangeDocumentList] = useState<File[]>([]);
    const [inputDocumentNameList, ChangeDocumentNameList] = useState<string[]>([]);
    const [isErrorDocumentListLength, ErrorDocumentListLength] = useState(false);

    // プロフェッショナル
    const [inputVideoProfessional, InputVideoProfessional] = useState("-1");

    // タグ選択モーダル画面表示制御
    const [tagList, setTagList] = React.useState<string[]>([]);
    const [isOpenTagSelectModal, ShowTagSelectModal] = useState(false);

    // グループ選択
    const [groupIds, setGroupIds] = useState<number[]>([]);
    const [inputGroup, setInputGroup] = useState<string[]>(["選択なし"]);

    // アップロードモーダルの変更があるかどうか
    const [isEditUploadTimeline, setIsEditUploadTimeline] = useState(false);
    // アップロードボタンの有無効制御
    const [isReadyUploadTimeline, setReadyUploadTimeline] = useState<boolean>(false);

    //Addアイコンにマウス入る処理
    const [isMouseEnterInfo, setMouseEnterInfo] = useState<boolean>(false);

    const UserInputVideoProfessional = (event: any) => {
        InputVideoProfessional(event.target.value);
    };
    const UserInputVideoGroup = (event: any) => {
        const groupNames = event.target.value;
        if (groupNames.includes("選択なし")) groupNames.splice(0, 1);
        let groupIds = [];
        for (let i = 0; i < groupNames.length; i++) {
            const targetGroup = groupList.find((item) => item.title === groupNames[i]);
            if (targetGroup) groupIds.push(Number(targetGroup.id));
        }
        if (event.target.value) {
            setInputGroup(event.target.value);
            if (groupIds) setGroupIds(groupIds);
        }
    };

    const UserInputVideoDescription = (event: any) => {
        InputVideoDetail(event.target.value);
    };

    // タグ選択モーダル表示
    const OpenTagSelectModal = () => {
        ShowTagSelectModal(true);
    };

    // タグ選択モーダル非表示
    const CloseTagSelectModal = () => {
        ShowTagSelectModal(false);
        dispatch(ResetDuplicateError());
    };

    // 画像ファイルアップロードテキスト
    const [textUploadImage, ChangeTextUploadImage] = useState("");
    const [isLimitInputImageSize, ChangeLimitInputImageSize] = useState(false);
    const UserUploadImage = (event: any) => {
        if (event.target.files.length === 0) {
            ChangevisiblePreviewImage(false);
            ChangeTextUploadImage("Videoサムネイル用のファイルを選択");
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        } else if (event.target.files.length === 1) {
            if (event.target.files[0].size > 0) {
                if (event.target.files[0].size > 10485760) {
                    ChangeLimitInputImageSize(true);
                    if (inputImageRef.current) {
                        inputImageRef.current.value = "";
                    }
                } else {
                    UserInputImageFile(event);
                    ChangeTextUploadImage(event.target.files[0].name);
                    InputImageFile(event.target.files[0]);
                    ChangevisiblePreviewImage(true);
                }
            } else {
                ChangeErrorInputSize(true);
                if (inputImageRef.current) {
                    inputImageRef.current.value = "";
                }
            }
        } else {
            ChangevisiblePreviewImage(false);
            ChangeTextUploadImage("ファイルを正しく選択してください");
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        }
        setIsSaved(false);
    };

    const [isErrorInputSize, ChangeErrorInputSize] = useState(false);
    // ファイルサイズエラーバー消去
    const CloseErrorInputBar = () => {
        ChangeErrorInputSize(false);
    };

    // サムネイルサイズ制限バー消去
    const CloseLimitInputImageBar = () => {
        ChangeLimitInputImageSize(false);
    };

    // ユーザのプレビュー画像クリックで、テキスト表示に戻す
    const ClickPreviewImage = (event: any) => {
        ChangeTextUploadImage("");
        InputImageFile(null);
        ChangevisiblePreviewImage(false);
        setIsSaved(false);
    };

    const UserInputImageFile = (event: any) => {
        InputImageFile(event.target.files[0]);
        setIsSaved(false);
    };

    // タイトルを入力する際に実行
    const handleChangeTitle = (event: any) => {
        if (countCharLength(event.target.value) > 80) {
            UserInputVideoName(event.target.value);
            CheckTitleValidation(true);
        } else {
            CheckTitleValidation(false);
            UserInputVideoName(event.target.value);
        }
    };

    // 要約を入力する際に実行
    const handleChangeDescription = (event: any) => {
        if (countCharLength(event.target.value) > 400) {
            UserInputVideoDescription(event);
            CheckDescriptionValidation(true);
        } else {
            CheckDescriptionValidation(false);
            UserInputVideoDescription(event);
        }
    };

    // ユーザキャンセルボタン押下
    const handleCancelUpdateTimeline = () => {
        if (isEditUploadTimeline) {
            setIsOpenLeaveDialogProp(true);
            return false;
        }
        closeUploadTimelineModal(true);
    };

    // 入力内容をバックエンドに送信
    const handleUpdateTimeline = () => {
        if (
            inputVideoName !== "" &&
            inputVideoDetail !== "" &&
            inputVideoProfessional !== "-1" &&
            inputVideoProfessional !== "" &&
            !isErrorTitleValidation &&
            !isErrorDescriptionValidation
        ) {
            dispatch(
                UploadTimeline({
                    imageFile: inputImageFile,
                    documentFile: inputDocumentList,
                    documentName: inputDocumentNameList,
                    timeLineInfo: {
                        id: timelineInfo.id,
                        filename: timelineInfo.name + ".mp4",
                        title: inputVideoName,
                        description: inputVideoDetail,
                        presenterId: Number(inputVideoProfessional),
                        tagList: tagList,
                        groupList: groupIds,
                    },
                })
            );
            if (setIsOpenReuploadModal) {
                setIsOpenReuploadModal(false);
            }
            ShowUploadTimelineModal(false);
        }
    };

    // ユーザーのタグを消去
    const handleDelete = (tagName: string) => () => {
        setTagList((tagList) => tagList.filter((v) => v !== tagName));
    };

    // OnLeaveDialogの「OK」ボタンをクリックで表示を閉じる
    const handleCloseOnLeaveDialog = () => {
        closeUploadTimelineModal(true);
    };

    // OnLeaveDialogの「キャンセル」ボタンをクリックで表示を閉じる
    const handleCancelOnLeaveDialog = () => {
        setIsOpenLeaveDialogProp(false);
    };

    // OnLeaveDialogの「OK」ボタンをクリックで表示を閉じる
    const handleConfirm = () => {
        handleCloseOnLeaveDialog();
    };

    useEffect(() => {
        if (groupList && groupList.length === 0) {
            dispatch(GetGroupList());
        }
        // eslint-disable-next-line
    }, []);

    // ビデオ削除後、一覧画面に戻る
    useEffect(() => {
        // API呼び出し用、対応時にコメントアウトを外す
        // dispatch(UploadTimeline(timelineInfo));
        dispatch(GetUserInfoList());
    }, [dispatch, timelineInfo]);

    // アップロードボタンの有無効制御
    useEffect(() => {
        if (
            inputVideoName !== "" &&
            inputVideoDetail !== "" &&
            inputVideoProfessional !== "-1" &&
            inputVideoProfessional !== "" &&
            !isErrorTitleValidation &&
            !isErrorDescriptionValidation &&
            !isErrorDocumentListLength
        ) {
            setReadyUploadTimeline(true);
        } else {
            setReadyUploadTimeline(false);
        }

        if (
            !isSaved ||
            inputVideoName !== timelineInfo.title ||
            inputVideoDetail !== "" ||
            inputVideoProfessional !== "-1"
        ) {
            setIsEditUploadTimeline(true);
            setIsEditUploadTimelineProp(true);
        } else {
            setIsEditUploadTimeline(false);
            setIsEditUploadTimelineProp(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSaved,
        timelineInfo.title,
        inputVideoName,
        inputVideoDetail,
        inputVideoProfessional,
        isErrorTitleValidation,
        isErrorDescriptionValidation,
        isErrorDocumentListLength,
    ]);

    return (
        <>
            <div className={styles.modal}>
                <IconButton className={styles.closeButton} onClick={handleCancelUpdateTimeline}>
                    <ClearIcon
                        style={{
                            color: "white",
                            fontSize: "40px",
                            top: "calc(2.5% - 12px)",
                            right: "calc(1% - 10px)",
                            position: "fixed",
                            padding: "8px",
                        }}
                    />
                </IconButton>
                <div className={styles.inputForm}>
                    <form name="addVideoForm" style={{ display: "flex" }}>
                        {/* Video */}
                        <div className={styles.formLeft}>
                            <li>
                                <div className={styles.leftformHelperText}>
                                    ビデオ
                                    <div className={styles.descripionText}>プロジェクト名</div>
                                </div>
                                <div className={styles.videoForm}>
                                    <video
                                        ref={videoRef}
                                        controls
                                        muted
                                        disablePictureInPicture
                                        controlsList="nodownload nofullscreen nodownload noremoteplayback"
                                        width="100%"
                                    >
                                        <source
                                            src={GetTimelineUrlFromId(timelineInfo.id)}
                                            type="video/mp4"
                                        />
                                        <p>Your browser doeosn't support HTML5 video.</p>
                                    </video>
                                </div>
                            </li>
                            <div className={styles.leftBorder} />
                            {/* 画像サムネイルファイル */}
                            <li>
                                <div className={styles.leftformHelperText}>
                                    サムネイル
                                    <div className={styles.descripionText}>
                                        ※pngかjpgファイルから追加ができます
                                    </div>
                                </div>

                                {visiblePreviewImage ? (
                                    inputImageFile !== null && (
                                        <div style={{ display: "flex" }}>
                                            <div className={styles.previewImage}>
                                                <img
                                                    style={{ cursor: "pointer" }}
                                                    alt="thumbnail"
                                                    src={window.URL.createObjectURL(inputImageFile)}
                                                    onClick={ClickPreviewImage}
                                                />
                                            </div>
                                            <p className={styles.previewText}>
                                                サムネイル画像を指定しない場合は、Videoから自動的にサムネイルが抽出されます
                                            </p>
                                        </div>
                                    )
                                ) : (
                                    <div className={styles.thumnailForm}>
                                        <Add
                                            style={{
                                                fontSize: "50px",
                                                cursor: "pointer",
                                                position: "absolute",
                                                width: "40px",
                                                marginTop: "35px",
                                                marginLeft: "85px",
                                            }}
                                        />
                                        <label className={styles.uploadButton}>
                                            <input
                                                id="browserPhotoUploader"
                                                ref={inputImageRef}
                                                multiple
                                                type="file"
                                                accept="image/*"
                                                onChange={UserUploadImage}
                                                className={styles.fileDisplay}
                                            />
                                            {textUploadImage}
                                        </label>
                                    </div>
                                )}
                            </li>
                        </div>
                        <div className={styles.rightForm}>
                            {/* タイトル */}
                            <ThemeProvider theme={theme}>
                                <li>
                                    <div className={styles.formHelperText}>
                                        タイトル
                                        <div className={styles.descripionText}>(必須)</div>
                                    </div>
                                    <div className={styles.form}>
                                        <TextField
                                            color="secondary"
                                            className={classes.title}
                                            id="videoName"
                                            variant="outlined"
                                            placeholder="Videoタイトルを入力"
                                            autoComplete="off"
                                            value={inputVideoName}
                                            onChange={handleChangeTitle}
                                            error={isErrorTitleValidation}
                                            helperText={
                                                isErrorTitleValidation && (
                                                    <span style={{ color: "var(--red)" }}>
                                                        全角40文字（半角80文字）以内で正しく入力してください
                                                    </span>
                                                )
                                            }
                                        />
                                    </div>
                                </li>

                                {/* プロフェッショナル */}
                                <li>
                                    <div className={styles.formHelperText}>
                                        投稿者
                                        <div className={styles.descripionText}>(必須)</div>
                                    </div>
                                    <div className={styles.form}>
                                        <>
                                            <Select
                                                required
                                                color="secondary"
                                                id="demo-simple-select"
                                                variant="outlined"
                                                defaultValue="-1"
                                                onChange={UserInputVideoProfessional}
                                                value={inputVideoProfessional}
                                                className={classes.formSelect}
                                            >
                                                <MenuItem value={"-1"}>選択なし</MenuItem>
                                                {professionals !== undefined &&
                                                    professionals.map(
                                                        (row) =>
                                                            row.roles.includes("PRESENTER") && (
                                                                <MenuItem
                                                                    key={row.id}
                                                                    value={row.id}
                                                                    className={classes.menuItem}
                                                                    style={{
                                                                        color:
                                                                            inputVideoProfessional ===
                                                                            row.id
                                                                                ? "rgba(1, 1, 1, 0.5)"
                                                                                : "rgba(255, 255, 255, 0.6)",
                                                                    }}
                                                                >
                                                                    {row.fullName}
                                                                </MenuItem>
                                                            )
                                                    )}
                                            </Select>
                                        </>
                                    </div>
                                </li>

                                {/* グループ（モーダル表示） */}
                                <li className={styles.mb50}>
                                    <div className={styles.formHelperTextLong}>グループ</div>
                                    <div className={styles.form}>
                                        <>
                                            <Select
                                                color="secondary"
                                                id="demo-simple-select"
                                                variant="outlined"
                                                onChange={UserInputVideoGroup}
                                                value={inputGroup}
                                                multiple
                                                displayEmpty
                                                renderValue={(selected: any) => {
                                                    if (selected.length === 0) {
                                                        return <em>選択なし</em>;
                                                    }

                                                    return selected.join(", ");
                                                }}
                                                MenuProps={MenuProps}
                                                className={classes.formSelect}
                                            >
                                                <MenuItem disabled value="">
                                                    <em>選択なし</em>
                                                </MenuItem>
                                                {groupList &&
                                                    groupList.map((row) => (
                                                        <MenuItem
                                                            key={row.id}
                                                            value={row.title}
                                                            className={classes.menuItem}
                                                            style={{
                                                                color: inputGroup.includes(
                                                                    row.title
                                                                )
                                                                    ? "#fff"
                                                                    : "rgba(255, 255, 255, 0.6)",
                                                                background: inputGroup.includes(
                                                                    row.title
                                                                )
                                                                    ? "rgba(1, 1, 1, 0.5)"
                                                                    : "",
                                                            }}
                                                        >
                                                            {/* <Checkbox
                                                                checked={
                                                                    inputGroup.indexOf(row.id) > -1
                                                                }
                                                            /> */}
                                                            {row.title}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </>
                                    </div>
                                </li>

                                {/* 要約 */}
                                <li>
                                    <div className={styles.formHelperTextLong}>
                                        内容
                                        <div className={styles.descripionText}>(必須)</div>
                                    </div>
                                    <div className={styles.form}>
                                        <TextField
                                            required
                                            color="secondary"
                                            id="description"
                                            onChange={handleChangeDescription}
                                            className={classes.textField}
                                            multiline
                                            minRows={8}
                                            autoComplete="off"
                                            value={inputVideoDetail}
                                            variant="outlined"
                                            placeholder="ビデオ内容を入力してください"
                                            error={isErrorDescriptionValidation}
                                            helperText={
                                                isErrorDescriptionValidation && (
                                                    <span style={{ color: "var(--red)" }}>
                                                        全角200文字（半角400文字）以内で正しく入力してください
                                                    </span>
                                                )
                                            }
                                        />
                                    </div>
                                </li>
                            </ThemeProvider>

                            <ul>
                                {/* タグ（モーダル表示） */}
                                <li className={styles.mb50}>
                                    <div className={styles.formHelperTextLong}>タグ</div>
                                    <div
                                        className={styles.formTag}
                                        onMouseEnter={() => setMouseEnterInfo(true)}
                                        onMouseLeave={() => setMouseEnterInfo(false)}
                                    >
                                        {!isMouseEnterInfo && (
                                            <img
                                                style={{
                                                    cursor: "pointer",
                                                }}
                                                alt={"More"}
                                                onClick={OpenTagSelectModal}
                                                src={require("../../../assets/image/MoreIcon.svg")}
                                            />
                                        )}
                                        {isMouseEnterInfo && (
                                            <img
                                                style={{
                                                    cursor: "pointer",
                                                }}
                                                alt={"More"}
                                                onClick={OpenTagSelectModal}
                                                src={require("../../../assets/image/MoreIcon_hover.svg")}
                                            />
                                        )}
                                    </div>

                                    {tagList && tagList.length > 0 && (
                                        <div className={styles.tags}>
                                            {tagList.map((tag) => (
                                                <Chip
                                                    label={tag}
                                                    key={tag}
                                                    color="secondary"
                                                    style={{
                                                        backgroundColor: "var(--studio-btn-bg)",
                                                    }}
                                                    size="medium"
                                                    className={styles.tag}
                                                    onDelete={handleDelete(tag)}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </li>

                                {/* 資料 */}
                                <li>
                                    <div className={styles.formHelperTextLong}>資料</div>
                                    <div style={{ marginLeft: "65px" }}>
                                        <UploadDocument
                                            isShowAddDocIcon={true}
                                            alreadyUploadDocumentList={[]}
                                            setIsSaved={setIsSaved}
                                            ChangeDocumentList={ChangeDocumentList}
                                            documentList={inputDocumentList}
                                            ChangeDocumentNameList={ChangeDocumentNameList}
                                            documentNameList={inputDocumentNameList}
                                            ErrorDocumentListLength={ErrorDocumentListLength}
                                        />
                                    </div>
                                </li>
                            </ul>

                            {/* アップロードボタン */}
                            <div className={styles.buttonGroup}>
                                {
                                    <PuiFloatButton
                                        type="submit"
                                        children={["cineonhubへアップロード"]}
                                        size="medium"
                                        onClick={handleUpdateTimeline}
                                        color="primary"
                                        isActive={isReadyUploadTimeline}
                                    />
                                }
                            </div>
                        </div>
                    </form>
                </div>
                {/*------------------------ タグ編集モーダル ------------------------*/}
                <Modal open={isOpenTagSelectModal} onClose={CloseTagSelectModal}>
                    <SelectTag
                        in={isOpenTagSelectModal}
                        onClose={CloseTagSelectModal}
                        tagList={tagList}
                        setTagList={setTagList}
                        setIsSaved={setIsSaved}
                        isShowStudio={true}
                    />
                </Modal>
                {/* 既にファイルがアップロードして再度別のファイルをアップロードする場合、ダイアログ表示 */}
                <OnLeaveDialog
                    openDialog={isOpenLeaveDialogProp}
                    dialogTitle={"コンテンツアップロード確認"}
                    dialogContent={"現在アップロードしているコンテンツファイルは失われます"}
                    dialogActions={"OK"}
                    handleCloseDialog={handleCloseOnLeaveDialog}
                    handleCancel={handleCancelOnLeaveDialog}
                    handleConfirm={handleConfirm}
                />
                {/* アップロードイメージサムネイルサイズチェック */}
                <PuiMessage
                    open={isLimitInputImageSize}
                    onClose={CloseLimitInputImageBar}
                    type="error"
                    title="10MB以上の画像はアップロードできません"
                    duration={5000}
                />
                <PuiMessage
                    open={isErrorInputSize}
                    type="error"
                    title="正しいファイルを選択してください"
                    duration={5000}
                    onClose={CloseErrorInputBar}
                />
            </div>
        </>
    );
}

export default UpdateTimelineModal;
